import { getDurationString } from '../../utils/date';

interface DurationPipeOptions {
  useAbbr?: boolean;
  separateUnits?: boolean;
  precision?: number;
}

export interface DurationProps {
  duration: number;
  options?: DurationPipeOptions;
}

export default function Duration({ duration, options = {} }: DurationProps) {
  return (
    <span>
      {duration === 0
        ? '-'
        : getDurationString(duration, options.useAbbr, options.separateUnits, options.precision)}
    </span>
  );
}
